(function () {
  'use strict';
  var config = window.SoulyshineGazeMap;
  if (!config || config.handle !== '50-dog-breeds-flowers-for-you-charm-necklace-set' || window.__ssGazeInstalled) return;
  window.__ssGazeInstalled = true;
  var states = new Map(), boundForms = new WeakSet();
  var selector = '[data-high-variant-picker="true"]';
  function pickerFor(target) {
    var picker = target && target.closest && target.closest(selector);
    return picker && picker.dataset.url === config.productUrl ? picker : null;
  }
  function controls(picker) { return Array.from(picker.querySelectorAll('select, input[type="radio"]:checked')); }
  function values(picker) { return controls(picker).map(function (el) { return el.value; }); }
  function variantId(info) {
    var el = info && info.querySelector('form[action*="/cart/add"] input[name="id"], input.product-variant-id[name="id"]');
    if (el && el.value) return el.value;
    // This theme can render the selected variant in payment terms while leaving
    // both product forms' hidden variant inputs blank on the initial page load.
    var terms = info && info.querySelector('shopify-payment-terms[variant-id]');
    return terms && terms.getAttribute('variant-id');
  }
  function sectionFor(picker) { return document.getElementById('MainProduct-' + picker.dataset.section); }
  function currentImage(picker) {
    var breedSelect = picker.querySelector('.product-form__input--option-choose-breed select');
    var material = picker.querySelector('.product-form__input--option-material input:checked, .product-form__input--option-material select');
    var breed = breedSelect && breedSelect.value, finish = material && material.value;
    var pair = config.images[breed], color = config.materialColors[finish];
    return pair && color ? { url: pair[color], alt: breed + ' — ' + finish } : null;
  }
  function hidden(form, name, value) {
    var input = Array.from(form.querySelectorAll('input')).find(function (el) { return el.name === name; });
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.appendChild(input); }
    input.value = value;
  }
  function syncForms(picker) {
    var state = states.get(picker.dataset.section), section = sectionFor(picker), image = currentImage(picker);
    if (!state || state.busy || !section || !image) return;
    section.dataset.soulyshineVariantId = state.variant;
    section.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.querySelectorAll('input[name="id"]').forEach(function (input) { input.value = state.variant; });
      hidden(form, 'properties[_soulyshine_variant_image]', image.url);
      hidden(form, 'properties[_soulyshine_variant_image_alt]', image.alt);
      if (!boundForms.has(form)) {
        boundForms.add(form);
        form.addEventListener('formdata', function (event) {
          var current = section.querySelector(selector), live = current && states.get(current.dataset.section);
          var preview = current && currentImage(current);
          if (live && !live.busy && preview) {
            event.formData.set('id', live.variant);
            event.formData.set('properties[_soulyshine_variant_image]', preview.url);
            event.formData.set('properties[_soulyshine_variant_image_alt]', preview.alt);
          }
        });
      }
    });
  }
  function syncCartData(section) {
    var picker = section && section.querySelector(selector);
    if (!picker) return;
    var state = states.get(picker.dataset.section), info = document.getElementById('ProductInfo-' + picker.dataset.section);
    var id = state && !state.busy && state.variant || section.dataset.soulyshineVariantId || variantId(info);
    var image = currentImage(picker);
    if (!id) return;
    section.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.querySelectorAll('input[name="id"]').forEach(function (input) {
        input.value = id;
        input.setAttribute('value', id);
      });
      if (image) {
        hidden(form, 'properties[_soulyshine_variant_image]', image.url);
        hidden(form, 'properties[_soulyshine_variant_image_alt]', image.alt);
      }
    });
  }
  function restore(picker, previous) {
    Array.from(picker.querySelectorAll('select')).forEach(function (el, i) { el.value = previous[i]; });
    var groups = Array.from(picker.querySelectorAll('.product-form__input')).filter(function (el) { return el.querySelector('select, input[type="radio"]'); });
    groups.forEach(function (group, index) { group.querySelectorAll('input[type="radio"]').forEach(function (input) { input.checked = input.value === previous[index]; }); });
  }
  function updatePreview(picker, activate) {
    var breed = picker.querySelector('.product-form__input--option-choose-breed select')?.value;
    var material = picker.querySelector('.product-form__input--option-material input:checked, .product-form__input--option-material select')?.value;
    var colors = ['silver', 'gold', 'rose'], labels = ['Silver', 'Gold', 'Rose Gold'];
    if (!config.images[breed]) return;
    var selected = config.materialColors[material] || 'silver', section = sectionFor(picker);
    if (!section) return;
    function image(img, color, small) {
      var url = new URL(config.images[breed][color], location.origin);
      var modal = !!img.closest('.product-media-modal__content');
      url.searchParams.set('width', small ? '240' : modal ? '1500' : matchMedia('(max-width: 749px)').matches ? '1000' : '1500');
      url.searchParams.set('height', url.searchParams.get('width'));
      url.searchParams.set('crop', 'center');
      img.loading = modal ? 'lazy' : 'eager';
      img.fetchPriority = !small && !modal && color === selected ? 'high' : 'low';
      img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.removeAttribute('data-srcset');
      if (img.src !== url.toString()) img.src = url.toString();
      img.alt = breed + ' — ' + labels[colors.indexOf(color)];
    }
    section.querySelectorAll('media-gallery').forEach(function (gallery) {
      var key = breed + '|' + selected;
      var changed = gallery.dataset.ssInstantSelection !== key;
      gallery.dataset.ssInstantSelection = key;
      gallery.dataset.ssGazeKey = key;
      var slides = Array.from(gallery.querySelectorAll('.product__media-list > li'));
      slides.slice(Number(gallery.dataset.ssSupplementalCount || 0), Number(gallery.dataset.ssSupplementalCount || 0) + 3).forEach(function (slide, index) {
        slide.querySelectorAll('.product__media img').forEach(function (img) { image(img, colors[index], false); });
        slide.dataset.alt = breed + ' — ' + labels[index];
        var thumb = gallery.querySelector('[data-target="' + CSS.escape(slide.dataset.mediaId) + '"]');
        thumb?.querySelectorAll('img').forEach(function (img) { image(img, colors[index], true); });
      });
      var list = gallery.querySelector('.product__media-list');
      if (list) list.style.setProperty('scroll-behavior', 'auto', 'important');
      var active = slides[Number(gallery.dataset.ssSupplementalCount || 0) + colors.indexOf(selected)];
      if (activate !== false && changed && active && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(active.dataset.mediaId, false);
    });
    document.getElementById('ProductModal-' + picker.dataset.section)?.querySelectorAll('.product-media-modal__content img').forEach(function (img, index) {
      var offset = Number(section.querySelector('media-gallery')?.dataset.ssSupplementalCount || 0);
      if (index >= offset && index < offset + 3) image(img, colors[index - offset], false);
    });
  }
  async function select(picker, changed) {
    var sectionId = picker.dataset.section, section = sectionFor(picker), info = document.getElementById('ProductInfo-' + sectionId);
    var state = states.get(sectionId), requested = values(picker);
    if (!state || state.busy || !section || !info) { if (state) restore(picker, state.values); return; }
    var optionIds = controls(picker).map(function (el) { return (el.matches('select') ? el.selectedOptions[0] : el).dataset.optionValueId; });
    if (optionIds.length !== 2 || optionIds.some(function (id) { return !id; })) return;
    var preview = currentImage(picker); if (!preview || !preview.url) { restore(picker, state.values); return; }
    state.busy = true; section.removeAttribute('data-variant-error'); picker.setAttribute('aria-busy', 'true'); info.setAttribute('aria-busy', 'true');
    var disabled = Array.from(section.querySelectorAll('button[name="add"], .product-form__submit, ' + selector + ' select, ' + selector + ' input[type="radio"]')).map(function (el) { var entry = {el:el, disabled:el.disabled}; el.disabled = true; return entry; });
    var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 30000);
    var request = new URL(config.productUrl, location.origin); request.searchParams.set('section_id', sectionId); request.searchParams.set('option_values', optionIds.join(','));
    try {
      updatePreview(picker);
      var response = await fetch(request, { credentials:'same-origin', headers:{'X-Requested-With':'XMLHttpRequest'}, signal:controller.signal });
      if (!response.ok) throw new Error('Variant request failed');
      var parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      var nextInfo = parsed.getElementById('ProductInfo-' + sectionId), nextPicker = nextInfo && nextInfo.querySelector(selector), nextVariant = variantId(nextInfo);
      if (!nextPicker || !nextVariant || JSON.stringify(values(nextPicker)) !== JSON.stringify(requested)) throw new Error('Variant response did not match the selected options');
      var gallery = document.getElementById('MediaGallery-' + sectionId), nextGallery = parsed.getElementById('MediaGallery-' + sectionId);
      var expectedMedia = nextGallery && Number(nextGallery.dataset.ssGazeCount || 3);
      if (!nextGallery || expectedMedia < 3 || nextGallery.querySelectorAll('.product__media-list > li').length !== expectedMedia) throw new Error('Expected all metal previews and supplemental images');
      var shipping = info.querySelector('[id*="synctrack_edd_omega_estimated_shipping"]'), nextShipping = nextInfo.querySelector('[id*="synctrack_edd_omega_estimated_shipping"]');
      if (shipping && nextShipping) nextShipping.replaceWith(shipping);
      // Commit cart data only after Shopify validates the selected variant.
      if (!gallery || gallery.dataset.ssGazeKey !== nextGallery.dataset.ssGazeKey) {
        if (gallery) gallery.replaceWith(nextGallery);
        var duplicate = document.getElementById('MediaGallery-' + sectionId + '-duplicate'), nextDuplicate = parsed.getElementById('MediaGallery-' + sectionId + '-duplicate');
        if (duplicate && nextDuplicate) duplicate.replaceWith(nextDuplicate);
        var modal = document.getElementById('ProductModal-' + sectionId), nextModal = parsed.getElementById('ProductModal-' + sectionId);
        if (modal && nextModal) modal.replaceWith(nextModal);
      }
      info.replaceWith(nextInfo);
      state.values = requested; state.variant = nextVariant; state.busy = false; state.revision += 1;
      syncForms(nextPicker); updatePreview(nextPicker);
      var revision = state.revision;
      [100,500,1500,3000,10000].forEach(function (delay) { setTimeout(function () { if (nextPicker.isConnected && state.revision === revision) syncForms(nextPicker); }, delay); });
      var nextUrl = new URL(location.href); nextUrl.searchParams.set('variant', nextVariant); nextUrl.searchParams.delete('option_values'); nextUrl.searchParams.delete('section_id'); history.replaceState({}, '', nextUrl);
      document.dispatchEvent(new CustomEvent('soulyshine:variant:updated', {detail:{picker:nextPicker}}));
      if (changed && changed.matches('input[type="radio"]')) {
        var replacement = Array.from(nextPicker.querySelectorAll('input[type="radio"]')).find(function (el) { return el.name === changed.name && el.value === changed.value; });
        if (replacement) replacement.focus({preventScroll:true});
      }
    } catch (error) {
      state.busy = false; restore(picker, state.values); updatePreview(picker);
      disabled.forEach(function (entry) { if (entry.el.isConnected) entry.el.disabled = entry.disabled; });
      picker.removeAttribute('aria-busy'); info.removeAttribute('aria-busy'); section.setAttribute('data-variant-error','true');
      var message = info.querySelector('[data-ss-gaze-error]');
      if (!message) { message = document.createElement('p'); message.dataset.ssGazeError = 'true'; message.setAttribute('role','alert'); picker.after(message); }
      message.textContent = 'We could not update this selection. Your previous choice is still selected. Please try again.';
      syncForms(picker); console.warn('[Soulyshine Gaze]', error.message);
    } finally { clearTimeout(timer); }
  }
  document.addEventListener('change', function (event) {
    var picker = pickerFor(event.target); if (!picker || !event.target.matches('select, input[type="radio"]')) return;
    event.stopImmediatePropagation(); select(picker,event.target);
  }, true);
  ['click','submit'].forEach(function (type) { document.addEventListener(type, function (event) {
    var target = event.target.closest && event.target.closest('button[name="add"], .product-form__submit, form[action*="/cart/add"]');
    var section = target && target.closest('[id^="MainProduct-"]'), picker = section && section.querySelector(selector);
    if (!pickerFor(picker)) return; var state = states.get(picker.dataset.section);
    if (!state || state.busy) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    syncForms(picker); syncCartData(section);
  }, true); });
  document.addEventListener('formdata', function (event) {
    var form = event.target, section = form && form.closest && form.closest('[id^="MainProduct-"]');
    var picker = section && section.querySelector(selector), state = picker && states.get(picker.dataset.section);
    var id = state && !state.busy && state.variant || section && section.dataset.soulyshineVariantId || variantId(picker && document.getElementById('ProductInfo-' + picker.dataset.section));
    var image = picker && currentImage(picker);
    if (!id) return;
    event.formData.set('id', id);
    if (image) {
      event.formData.set('properties[_soulyshine_variant_image]', image.url);
      event.formData.set('properties[_soulyshine_variant_image_alt]', image.alt);
    }
  }, true);
  function start() {
    document.querySelectorAll(selector).forEach(function (picker) {
      if (!pickerFor(picker)) return;
      var info = document.getElementById('ProductInfo-' + picker.dataset.section), variant = variantId(info);
      if (!variant) return;
      states.set(picker.dataset.section,{values:values(picker),variant:variant,busy:false,revision:0}); syncForms(picker); updatePreview(picker, false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
